import { useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";

import { Impulse } from "~/tools/impulse";

import { setLastSelectedDynamicInterval } from "../../../app/state/view/timeline/TimelineActions";
import { selectTimeRange } from "../../../app/state/view/timeline/TimelineSelectors";
import type { TimeRange } from "../../../app/state/view/timeline/TimeRange";
import { useNavigateFrom } from "../link";

export const useTimelineInterval = (): Impulse<TimeRange> => {
	const dispatch = useDispatch();
	const navigateFrom = useNavigateFrom();
	const timeRange = useSelector(selectTimeRange);

	return useMemo(
		() =>
			Impulse(
				() => timeRange,
				(nextTimeRange) => {
					if (!nextTimeRange.isSpecific()) {
						dispatch(setLastSelectedDynamicInterval(nextTimeRange));
					}

					navigateFrom("*", {
						search: (search) => ({
							...search,
							timestamp: nextTimeRange.isSpecific() ? search.timestamp : undefined,
							timeRange: nextTimeRange,
						}),
					});
				},
			),
		[dispatch, navigateFrom, timeRange],
	);
};
